import { useApolloClient } from "@apollo/client";
import { useObservabilityConfig, useProject } from "@sail/observability";
import { useMemoizedValue } from "@sail/react";
import * as React from "react";
import PrefetchEnvContext from "../prefetching/PrefetchEnvContext";
import PruningPrefetchCacheContext from "../prefetching/PruningPrefetchCacheContext";
import useDefaultFetchPolicy from "../prefetching/useDefaultFetchPolicy";
import useObservabilityFns from "../shared/observability/useObservabilityFns";
import useDataConfig from "../../public/useDataConfig";
export default function useGetApolloContext(options) {
    var _useObservabilityConfig;
    const dataConfig = useDataConfig();
    const defaultFetchPolicy = useDefaultFetchPolicy();
    const fetchPolicy = options.fetchPolicy || defaultFetchPolicy;
    const memoizedExpectedErrors = useMemoizedValue(options.expectedErrors);
    const memoizedMutedErrors = useMemoizedValue(options.mutedErrors);
    const pruningSignal = React.useContext(PruningPrefetchCacheContext);
    const token = options.token;
    const { isPrefetchMode } = React.useContext(PrefetchEnvContext);
    const client = useApolloClient();
    const observabilityFns = useObservabilityFns();
    const queryProject = useProject();
    const service = (_useObservabilityConfig = useObservabilityConfig()) === null || _useObservabilityConfig === void 0 ? void 0 : _useObservabilityConfig.service;
    const { expectedApiErrors, mutedApiErrors } = dataConfig.observability;
    const computedExpectedErrors = React.useMemo(()=>{
        return expectedApiErrors.concat(memoizedExpectedErrors !== null && memoizedExpectedErrors !== void 0 ? memoizedExpectedErrors : []);
    }, [
        memoizedExpectedErrors,
        expectedApiErrors
    ]);
    const computedMutedErrors = React.useMemo(()=>{
        return mutedApiErrors.concat(memoizedMutedErrors !== null && memoizedMutedErrors !== void 0 ? memoizedMutedErrors : []);
    }, [
        memoizedMutedErrors,
        mutedApiErrors
    ]);
    const fetch = dataConfig.fetch;
    return React.useMemo(()=>{
        const fetchOptions = {
            keepalive: !!options.keepAlive
        };
        const context = {
            client,
            component: options.component,
            expectedErrors: computedExpectedErrors,
            fetch,
            fetchOptions,
            fetchPolicy,
            isPrefetchMode,
            prefetchCachePruningSignal: pruningSignal,
            mutedErrors: computedMutedErrors,
            observabilityFns,
            queryProject,
            service,
            token
        };
        return context;
    }, [
        client,
        computedExpectedErrors,
        computedMutedErrors,
        fetch,
        fetchPolicy,
        isPrefetchMode,
        observabilityFns,
        options.component,
        options.keepAlive,
        pruningSignal,
        queryProject,
        service,
        token
    ]);
}

//# sourceMappingURL=useGetApolloContext.js.map